import { connect } from 'react-redux';
import { property } from 'lodash';
import ContentWrapper from '../components/ContentWrapper';
import { getInfo as getUserInfo } from '../redux/user/actions';
import { startRequest as getContactInfo } from '../../Profile/redux/contactInfo/actions';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';
import { replace } from 'redux-little-router';
import { routeMap } from '../../../router';
import { startRequest as startRequestToGetAdminConfig } from '../redux/adminConfig/actions';
import configTypes from '../../../constants/configObjectTypes';
import { selectRouter } from 'modules/App/utils/selectors';

const mapStateToProps = createStructuredSelector({
  user: property('app.user'),
  router: selectRouter,
  incomingData: property('app.incomingData'),
  contactInfo: property('profile.contactInfo'),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getUserInfo,
      getContactInfo,
      goToHomePage: () => replace(routeMap.home),
      loadModalConfig: () => startRequestToGetAdminConfig(configTypes.modal),
      loadSituationsConfig: () => startRequestToGetAdminConfig(configTypes.situations),
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(ContentWrapper);
